import React from "react"
import './componentTool.css'

// 使用现有图片作为占位符
import questionImg from '../ToolImg/tabBar/mainImg.png'  // Questions Tab
import roleImg from '../ToolImg/tabBar/listImg.png'      // Role Tab
import mineImg from '../ToolImg/tabBar/mineImg.png'      // Mine Tab

class TabBarView extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            activeTab: 1,
            userRoleType: "1"  // 1 = worker/candidate, 2 = employer/recruiter
        }
    }

    componentDidMount() {
        // 获取用户角色类型
        let userInfo = localStorage.getItem("initUser");
        if (userInfo) {
            let userJson = JSON.parse(userInfo);
            let jobType = userJson["jobType"] || 1;
            this.setState({ userRoleType: jobType });
        }
    }

    clickBtn = (parame) => {
        this.setState({ activeTab: parame });
        this.props.onClick(parame)
    }

    render(){
        const roleLabel = this.state.userRoleType === 1 ? "Work" : "Recruiter";

        return(
            <div className="TabContentV">
                <div
                    className={`TabViewV ${this.state.activeTab === 1 ? 'active' : ''}`}
                    onClick={() => this.clickBtn(1)}
                >
                    <img className="tabImgV" src={questionImg} alt="Questions"></img>
                    <p className="tabLabel">Questions</p>
                </div>

                <div
                    className={`TabViewV ${this.state.activeTab === 2 ? 'active' : ''}`}
                    onClick={() => this.clickBtn(2)}
                >
                    <img className="tabImgV" src={roleImg} alt="Role"></img>
                    <p className="tabLabel">{roleLabel}</p>
                </div>

                <div
                    className={`TabViewV ${this.state.activeTab === 3 ? 'active' : ''}`}
                    onClick={() => this.clickBtn(3)}
                >
                    <img className="tabImgV" src={mineImg} alt="Mine"></img>
                    <p className="tabLabel">Mine</p>
                </div>
            </div>
        )
    }
}

export default TabBarView